export const getSandboxData = ({ sandbox }) => sandbox.sandboxData;
export const getUrlCheckErrors = ({ sandbox }) => sandbox.errors;
export const getSandboxStatsData = ({ sandbox }) => sandbox.sandboxStats;
export const getSandboxLoaders = ({ sandbox }) => sandbox.loaders.common;
export const getSandboxMyAssetsDrop = ({ sandbox }) => sandbox.sandboxAssets;
export const getSandboxFileErrors = ({ sandbox }) => sandbox.fileError;
